/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import cx from "classnames";
import axios from "axios";
import TagManager from "react-gtm-module";
import { withRouter } from "react-router-dom";

import classes from "./Checkout.module.scss";
import FormTitle from "../FormTitle/FormTitle";
import * as ROUTES from "../../constants/routes";
import FormController from "../../components/FormController/FormController";
import CheckoutForm from "./CheckoutForm/CheckoutForm";
import PersonalForm from "./PersonalForm/PersonalForm";
import moment from "moment";
import checkIcon from "../../assets/images/check.png";
import CheckoutModal from "./CheckoutModal/CheckoutModal";
import CheckoutModalSchedule from "./CheckoutModal/CheckoutModalSchedule";
import ReactGA from "react-ga";
import Rollbar from "rollbar";
import { API_URL } from "../../config";

class Checkout extends Component {
  state = {
    loading: false,
    error: false,
    checkoutResult: "",
    cardInfoResult: "",
    personalInforResult: {},
    totalInfo: "",
    cartId: "",
    clientToken: "",
    validation: true,
    validationErrorMsg: "",
    checkoutSuccess: false,
    loaderShow: false,
    checkoutModalToggle: false,
    checkoutModalScheduleToggle: false,
    selectedPaymentPlan: {
      index: 0,
    },
    numOfTickets: null,
    rollbar: new Rollbar({
      accessToken: "0b54eebaa41c4349a528260a86c385f4",
      captureUncaught: false,
      captureUnhandledRejections: false,
    }),
  };
  componentDidMount() {
    this.setState({ loaderShow: true });

    if (this.props.formStart === "") {
      this.props.history.push("/");
    } else {
    }

    ReactGA.pageview("/checkout");

    let ticketQuantity = null;
    switch (this.props.formSize) {
      case "eightyFlexible":
        this.setState({ numOfTickets: this.props.numOfSeat * 80 });
        ticketQuantity = this.props.numOfSeat * 80;
        break;

      case "fortyFlexible":
        this.setState({ numOfTickets: this.props.numOfSeat * 40 });
        ticketQuantity = this.props.numOfSeat * 40;

        break;

      case "twentyFlexible":
        this.setState({ numOfTickets: this.props.numOfSeat * 20 });
        ticketQuantity = this.props.numOfSeat * 20;

        break;

      default:
        this.setState({ numOfTickets: this.props.numOfSeat });
        ticketQuantity = this.props.numOfSeat;

        break;
    }
    if (
      this.props["seatInfoSelected"] &&
      this.props["seatInfoSelected"] !== "" &&
      this.props["selectYourSeatsUuid"] !== ""
    ) {
      axios
        .post(
          `${API_URL}${
            this.props.formStyle === "classic"
              ? "/createTicketsCart"
              : "/createCart"
          }`,
          {
            q: ticketQuantity,
            uuid: this.props["selectYourSeatsUuid"],
            auid: this.props["seatInfoSelected"]["auid"],
            buid: this.props["buid"],
            sid: this.props["seatInfoSelected"]["section"], // section
            psid: this.props["seatInfoSelected"]["ps-key"], // ps-key
            bid: this.props["seatInfoSelected"]["buyers"][0], // buyers
            tids: this.props.selectedSeats, // Ticket ids
          }
        )
        .then((response) => {
          this.setState({
            totalInfo: response.data.info.costs,
            seatLocation: response.data.info.location,
            etag: response.data.info["patrons-create-etag"],
            paymentPlanOptions: response.data.info.costs.plans,
            selectedPaymentPlan: {
              ...this.state.selectedPaymentPlan,
              planPrice: response.data.info.costs.total,
              dueLater: response.data.info.costs.plans[0].dueLater,
              installments: response.data.info.costs.plans[1]
                ? response.data.info.costs.plans[1].installments
                : null,
              paymentType: "payinfull",
            },
            clientToken:
              response.data.info["braintree-request-result"]["braintreeToken"][
                "clientToken"
              ],
            cartId: response.data.info.cart,
            loaderShow: false,
          });

          return response.data.info.location;
        })
        .catch((error) => {
          this.setState({ error: true, loaderShow: false });
        });
    }
    this.createplans();
  }
  componentWillUnmount() {
    if (this.state.cartId) {
      axios
        .post(`${API_URL}/deleteCart`, {
          cart: this.state["cartId"],
        })
        .then((response) => {})
        .catch((error) => {
          this.setState({ error: true });
        });
    }
  }

  getState = (zipcode) => {
    //let thisst = '';
    let thisstate = "";
    // Ensure param is a string to prevent unpredictable parsing results
    if (typeof zipcode !== "string") {
      console.log("Must pass the zipcode as a string.");
      return;
    }
    // Ensure you don't parse codes that start with 0 as octal values
    const thiszip = parseInt(zipcode, 10);
    // Code blocks alphabetized by state
    if (thiszip >= 35000 && thiszip <= 36999) {
      //thisst = 'AL';
      thisstate = "Alabama";
    } else if (thiszip >= 99500 && thiszip <= 99999) {
      //thisst = 'AK';
      thisstate = "Alaska";
    } else if (thiszip >= 85000 && thiszip <= 86999) {
      //thisst = 'AZ';
      thisstate = "Arizona";
    } else if (thiszip >= 71600 && thiszip <= 72999) {
      //thisst = 'AR';
      thisstate = "Arkansas";
    } else if (thiszip >= 90000 && thiszip <= 96699) {
      //thisst = 'CA';
      thisstate = "California";
    } else if (thiszip >= 80000 && thiszip <= 81999) {
      //thisst = 'CO';
      thisstate = "Colorado";
    } else if (thiszip >= 6000 && thiszip <= 6999) {
      //thisst = 'CT';
      thisstate = "Connecticut";
    } else if (thiszip >= 19700 && thiszip <= 19999) {
      //thisst = 'DE';
      thisstate = "Delaware";
    } else if (thiszip >= 32000 && thiszip <= 34999) {
      //thisst = 'FL';
      thisstate = "Florida";
    } else if (thiszip >= 30000 && thiszip <= 31999) {
      //thisst = 'GA';
      thisstate = "Georgia";
    } else if (thiszip >= 96700 && thiszip <= 96999) {
      //thisst = 'HI';
      thisstate = "Hawaii";
    } else if (thiszip >= 83200 && thiszip <= 83999) {
      //thisst = 'ID';
      thisstate = "Idaho";
    } else if (thiszip >= 60000 && thiszip <= 62999) {
      //thisst = 'IL';
      thisstate = "Illinois";
    } else if (thiszip >= 46000 && thiszip <= 47999) {
      //thisst = 'IN';
      thisstate = "Indiana";
    } else if (thiszip >= 50000 && thiszip <= 52999) {
      //thisst = 'IA';
      thisstate = "Iowa";
    } else if (thiszip >= 66000 && thiszip <= 67999) {
      //thisst = 'KS';
      thisstate = "Kansas";
    } else if (thiszip >= 40000 && thiszip <= 42999) {
      //thisst = 'KY';
      thisstate = "Kentucky";
    } else if (thiszip >= 70000 && thiszip <= 71599) {
      //thisst = 'LA';
      thisstate = "Louisiana";
    } else if (thiszip >= 3900 && thiszip <= 4999) {
      //thisst = 'ME';
      thisstate = "Maine";
    } else if (thiszip >= 20600 && thiszip <= 21999) {
      //thisst = 'MD';
      thisstate = "Maryland";
    } else if (thiszip >= 1000 && thiszip <= 2799) {
      //thisst = 'MA';
      thisstate = "Massachusetts";
    } else if (thiszip >= 48000 && thiszip <= 49999) {
      //thisst = 'MI';
      thisstate = "Michigan";
    } else if (thiszip >= 55000 && thiszip <= 56999) {
      //thisst = 'MN';
      thisstate = "Minnesota";
    } else if (thiszip >= 38600 && thiszip <= 39999) {
      //thisst = 'MS';
      thisstate = "Mississippi";
    } else if (thiszip >= 63000 && thiszip <= 65999) {
      //thisst = 'MO';
      thisstate = "Missouri";
    } else if (thiszip >= 59000 && thiszip <= 59999) {
      //thisst = 'MT';
      thisstate = "Montana";
    } else if (thiszip >= 27000 && thiszip <= 28999) {
      //thisst = 'NC';
      thisstate = "North Carolina";
    } else if (thiszip >= 58000 && thiszip <= 58999) {
      //thisst = 'ND';
      thisstate = "North Dakota";
    } else if (thiszip >= 68000 && thiszip <= 69999) {
      //thisst = 'NE';
      thisstate = "Nebraska";
    } else if (thiszip >= 88900 && thiszip <= 89999) {
      //thisst = 'NV';
      thisstate = "Nevada";
    } else if (thiszip >= 3000 && thiszip <= 3899) {
      //thisst = 'NH';
      thisstate = "New Hampshire";
    } else if (thiszip >= 7000 && thiszip <= 8999) {
      //thisst = 'NJ';
      thisstate = "New Jersey";
    } else if (thiszip >= 87000 && thiszip <= 88499) {
      //thisst = 'NM';
      thisstate = "New Mexico";
    } else if (thiszip >= 10000 && thiszip <= 14999) {
      //thisst = 'NY';
      thisstate = "New York";
    } else if (thiszip >= 43000 && thiszip <= 45999) {
      //thisst = 'OH';
      thisstate = "Ohio";
    } else if (thiszip >= 73000 && thiszip <= 74999) {
      //thisst = 'OK';
      thisstate = "Oklahoma";
    } else if (thiszip >= 97000 && thiszip <= 97999) {
      //thisst = 'OR';
      thisstate = "Oregon";
    } else if (thiszip >= 15000 && thiszip <= 19699) {
      //thisst = 'PA';
      thisstate = "Pennsylvania";
    } else if (thiszip >= 300 && thiszip <= 999) {
      //thisst = 'PR';
      thisstate = "Puerto Rico";
    } else if (thiszip >= 2800 && thiszip <= 2999) {
      //thisst = 'RI';
      thisstate = "Rhode Island";
    } else if (thiszip >= 29000 && thiszip <= 29999) {
      //thisst = 'SC';
      thisstate = "South Carolina";
    } else if (thiszip >= 57000 && thiszip <= 57999) {
      //thisst = 'SD';
      thisstate = "South Dakota";
    } else if (thiszip >= 37000 && thiszip <= 38599) {
      //thisst = 'TN';
      thisstate = "Tennessee";
    } else if (
      (thiszip >= 75000 && thiszip <= 79999) ||
      (thiszip >= 88500 && thiszip <= 88599)
    ) {
      //thisst = 'TX';
      thisstate = "Texas";
    } else if (thiszip >= 84000 && thiszip <= 84999) {
      //thisst = 'UT';
      thisstate = "Utah";
    } else if (thiszip >= 5000 && thiszip <= 5999) {
      //thisst = 'VT';
      thisstate = "Vermont";
    } else if (thiszip >= 22000 && thiszip <= 24699) {
      //thisst = 'VA';
      thisstate = "Virginia";
    } else if (thiszip >= 20000 && thiszip <= 20599) {
      //thisst = 'DC';
      thisstate = "Washington DC";
    } else if (thiszip >= 98000 && thiszip <= 99499) {
      //thisst = 'WA';
      thisstate = "Washington";
    } else if (thiszip >= 24700 && thiszip <= 26999) {
      //thisst = 'WV';
      thisstate = "West Virginia";
    } else if (thiszip >= 53000 && thiszip <= 54999) {
      //thisst = 'WI';
      thisstate = "Wisconsin";
    } else if (thiszip >= 82000 && thiszip <= 83199) {
      //thisst = 'WY';
      thisstate = "Wyoming";
    } else {
      //thisst = 'none';
      thisstate = "none";
    }
    return thisstate;
  };
  onClickCheckoutSubmit = (title, checkoutInfo) => {
    if (this.isEmpty(this.state.personalInforResult.firstName)) {
      console.log("1");
      this.setState({
        validationErrorMsg: "First Name is required",
        validation: false,
      });
      return;
    }
    if (this.isEmpty(this.state.personalInforResult.lastName)) {
      console.log("2");
      this.setState({
        validationErrorMsg: "Last Name is required",
        validation: false,
      });
      return;
    }
    if (!this.isEmail(this.state.personalInforResult.email)) {
      console.log("3");
      this.setState({
        validationErrorMsg: "Invalid Email",
        validation: false,
      });
      return;
    }
    if (this.isEmpty(this.state.personalInforResult.address)) {
      console.log("4");
      this.setState({
        validationErrorMsg: "Address is required",
        validation: false,
      });
      return;
    }

    if (this.isEmpty(this.state.personalInforResult.phone)) {
      console.log("4-4");
      this.setState({
        validationErrorMsg: "Phone is required",
        validation: false,
      });
      return;
    }
    if (this.isEmpty(this.state.personalInforResult.zip)) {
      console.log("5");
      this.setState({
        validationErrorMsg: "Zip Code is required",
        validation: false,
      });
      return;
    }
    if (this.isEmpty(this.state.personalInforResult.state)) {
      console.log("51");
      this.setState({
        validationErrorMsg: "State is required",
        validation: false,
      });
      return;
    }
    if (this.getState(this.state.personalInforResult.zip) === "none") {
      console.log("6");
      this.setState({
        validationErrorMsg: "Zip Code is not valid",
        validation: false,
      });
      return;
    }

    if (
      checkoutInfo === null ||
      checkoutInfo === "undefined" ||
      title === "Error"
    ) {
      console.log("7");
      this.setState({
        validationErrorMsg: "Invalid Card Information",
        validation: false,
      });
      return;
    }

    if (
      this.props["seatInfoSelected"] === "" ||
      typeof this.props.seatInfoSelected == "undefined" ||
      this.props.seatInfoSelected === null
    ) {
      console.log("8");
      this.setState({
        validationErrorMsg:
          "Sorry! There is an error. Please click the “Chat with Representative” button below or e-mail us at TicketInfo@Nationals.com to finalize your order.",
        validation: false,
      });
      return;
    }
    this.setState({
      validationErrorMsg: "",
      validation: true,
      cardInfoResult: checkoutInfo,
      loaderShow: true,
    });

    axios
      .post(`${API_URL}/checkoutCart`, {
        price: this.state.selectedPaymentPlan.planPrice,
        paymentType: this.state.selectedPaymentPlan.paymentType,
        dueLater: this.state.selectedPaymentPlan.dueLater,
        service: this.state.totalInfo.serviceCharges,
        cart: this.state.cartId,
        uuid: this.props["selectYourSeatsUuid"],
        buid: this.props["buid"],
        auid: this.props["seatInfoSelected"]["auid"],
        sid: this.props["seatInfoSelected"]["section"],
        selectedArea: this.props.seatInfoSelected.name,
        location: this.state.seatLocation,
        "nonce-id": checkoutInfo.nonce,
        "card-identity": checkoutInfo.details,
        email: this.state.personalInforResult.email,
        last: this.state.personalInforResult.lastName,
        first: this.state.personalInforResult.firstName,
        phone: this.state.personalInforResult.phone,
        address: this.state.personalInforResult.address,
        city: this.state.personalInforResult.city,
        state: this.state.personalInforResult.state,
        zip: this.state.personalInforResult.zip,
        etag: this.state.etag.replace(/['/"]+/g, ""),
      })
      .then((response) => {
        setTimeout(() => {
          if (
            !response.data.info ||
            !response.data.info.orderId ||
            response.data.info.orderId === ""
          ) {
            console.log("error", response.data.message);
            this.state.rollbar.info(
              "Checkout Cart Error (data.info, data.info.orderId)",
              response.data
            );
            this.setState({
              validationErrorMsg: `Sorry! There is an error. Please click the “Chat with Representative” button below or e-mail us at TicketInfo@Nationals.com to finalize your order.`,
              loaderShow: false,
              validation: false,
            });
          } else if (response.data.status !== "error") {
            this.setState({
              checkoutSuccess: true,
              loaderShow: false,
              validation: true,
              validationErrorMsg: "",
              cartId: null,
            });

            const tagManagerArgs = {
              dataLayer: {
                event: "tixfinder_confirmation",
                Quantity: this.state.numOfTickets,
                Revenue: this.state.totalInfo.total.toLocaleString("en-US"),
                eventname: this.props.formSize,
                facevalue:
                  this.state.totalInfo.subTotal.toLocaleString("en-US"),
                dateofpur: Date(Date.now().toString()),
                billingstate: this.state.personalInforResult.state,
                billingzip: this.state.personalInforResult.zip,
                orderID: response.data.info ? response.data.info.orderId : "",
              },
              dataLayerName: "dataLayer",
            };
            TagManager.dataLayer(tagManagerArgs);

            let planTitle =
              this.state.planSchedules[this.props["selectYourSeatsUuid"]]
                .planTitle;
            let planName =
              this.state.planSchedules[this.props["selectYourSeatsUuid"]]
                .planName;

            // Adobe tracking
            if (window.adobeAnalytics) {
              window.adobeAnalytics.t({
                pageName:
                  "Washington Nationals: Tickets : Nationals Ticketfinder : Confirmation",
                events: "purchase",
                products: `Washington Nationals; ${planTitle} (${planName});${
                  this.state.numOfTickets
                };${this.state.totalInfo.subTotal.toLocaleString("en-US")}`,
              });
            }
          } else {
            console.log("error", response);
            this.state.rollbar.info(
              "Checkout Cart Error (response.data.status !== error)",
              response.data
            );
            this.setState({
              validationErrorMsg: `Sorry! There is an error. Please click the “Chat with Representative” button below or e-mail us at TicketInfo@Nationals.com to finalize your order, ${response.data.message} .`,
              loaderShow: false,
              validation: false,
            });
          }
        }, 2000);
      })
      .catch((error) => {
        console.log("error", error);
        this.state.rollbar.info(
          "Checkout Cart Error (promise catch error)",
          error
        );
        this.setState({
          validationErrorMsg: `Sorry! There is an error. Please click the “Chat with Representative” button below or e-mail us at TicketInfo@Nationals.com to finalize your order.`,
          loaderShow: false,
          validation: false,
        });
      });
  };

  onChangePersonalForm = (result) => {
    this.setState({
      personalInforResult: result,
    });
  };
  onClickCheckoutModalToggle = () => {
    this.setState({
      checkoutModalToggle: !this.state.checkoutModalToggle,
    });
  };
  onClickCheckoutModalScheduleToggle = () => {
    this.setState({
      checkoutModalScheduleToggle: !this.state.checkoutModalScheduleToggle,
    });
  };

  onChangePaymentPlan = (value) => {
    this.setState({
      selectedPaymentPlan: {
        ...this.state.selectedPaymentPlan,
        planId: value.id,
        paymentType:
          this.state.totalInfo.total === value.due ? "payinfull" : value.id,
        planPrice: value.due,
        dueLater: value.dueLater,
        index: value.index,
      },
    });
  };

  // validations
  isEmail = (email) => {
    // eslint-disable-next-line no-useless-escape
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
  };
  isEmpty = (value) => {
    return typeof value === "undefined" || value === "";
  };

  numberFormat = (number, decimals, dec_point, thousands_sep) => {
    // Strip all characters but numerical ones.
    number = (number + "").replace(/[^0-9+\-Ee.]/g, "");
    var n = !isFinite(+number) ? 0 : +number,
      prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
      sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
      dec = typeof dec_point === "undefined" ? "." : dec_point,
      s = "",
      toFixedFix = function (n, prec) {
        var k = Math.pow(10, prec);
        return "" + Math.round(n * k) / k;
      };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || "").length < prec) {
      s[1] = s[1] || "";
      s[1] += new Array(prec - s[1].length + 1).join("0");
    }
    return s.join(dec);
  };
  async createplans() {
    if (this.props.cms) {
      let _planSchedules = {};
      // let _scheduleSelectionValues = {};

      const cms = this.props.cms;

      await cms.forEach(async (style, index) => {
        await style.plans.forEach((plan) => {
          plan.schedules.forEach((schedule) => {
            _planSchedules[schedule.UUID] = {
              parkingLink: schedule.parkingUrl,
              planTitle: plan.name,
              planName: schedule.name,
              planDesc: schedule.desc,
              planSubTitle: schedule.name,
              flexMultiply: schedule.flexMultiply || 1,
              games: schedule?.games?.map(({ info }) => info),
            };
          });
        });
      });
      this.setState({
        planSchedules: _planSchedules,
      });

      let planTitle = _planSchedules[this.props.selectYourSeatsUuid]?.planTitle;
      let planName = _planSchedules[this.props.selectYourSeatsUuid]?.planName;
      // Adobe tracking

      if (window.adobeAnalytics) {
        window.adobeAnalytics.t({
          pageName:
            "Washington Nationals: Tickets: Nationals Ticketfinder: Checkout",
          events: "purchase",
          products: `Washington Nationals; ${planTitle} (${planName});${this.state.numOfTickets};`,
        });
      }
    }
  }
  render() {
    // console.log('this.props.seatInfoSelected', this.props.seatInfoSelected);
    if (
      !this.state.planSchedules ||
      !this.state.planSchedules[this.props["selectYourSeatsUuid"]]
    ) {
      return <p>Loading ...</p>;
    }
    let planTitle =
      this.state.planSchedules[this.props["selectYourSeatsUuid"]].planTitle;
    let planSubTitle =
      this.state.planSchedules[this.props["selectYourSeatsUuid"]].planSubTitle;
    let parkingLink =
      this.state.planSchedules[this.props["selectYourSeatsUuid"]].parkingLink;
    let rows = [];
    let section = "";
    let flexMultiply =
      this.state.planSchedules[this.props["selectYourSeatsUuid"]].flexMultiply;

    if (this.state.seatLocation) {
      rows.push(this.state.seatLocation.rows);

      const originalString = this.state.seatLocation.section;
      const substringToRemove = "Pnc Diamond Club ";
      const modifiedString = originalString.includes(substringToRemove)
        ? originalString.replace(substringToRemove, "")
        : originalString;
      section = modifiedString;
    }

    return (
      <>
        <FormTitle title="Checkout" />
        {this.state.checkoutSuccess ? (
          <div className={classes.Checkout}>
            <div className={classes.Checkout__success}>
              <h3>
                <img src={checkIcon} alt="" />
                Success!
              </h3>
              <h4>
                Thank you for your purchase. You will receive an e-mail with
                your receipt and other important information. Please be sure to
                check your Spam or Junk folder if you do not see the
                confirmation e-mail in your inbox.
              </h4>
              {(this.props.formSize === "eightyClassic" ||
                this.props.formSize === "fortyClassic" ||
                this.props.formSize === "twentyClassic") && (
                <>
                  <p>
                    Check out the link below to purchase a Parking package
                    corresponding to your schedule of games
                  </p>
                  <a
                    href={parkingLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Purchase Parking
                  </a>
                </>
              )}
            </div>
          </div>
        ) : (
          <div className={classes.Checkout_2}>
            {this.state.totalInfo !== "" ? (
              <>
                <div className={classes.Checkout}>
                  <div className={classes.orderSummary}>
                    <div className={classes.orderSummaryTitle}>Your Order</div>
                    <div className={classes.orderSummaryPlan}>
                      <span className={classes.labelName}>
                        {this.props.formStyle === "ballpark"
                          ? "Ballpark Access Pass"
                          : planTitle}
                        <br />
                        {/* {planSubTitle !== "82-game Classic Plan" &&
                        planSubTitle !== "80-Ticket Pick 'Em Plans" &&
                        planSubTitle !== "40-Ticket Pick 'Em Plans" 
                          ? `(${planSubTitle})`
                          : ""} */}
                        {planTitle !== planSubTitle &&
                        planSubTitle !== "Full Season Premier Plan"
                          ? `(${planSubTitle})`
                          : ""}
                        <br />
                        <br />
                        {(this.props.formSize === "eightyClassic" ||
                          this.props.formSize === "ballPark") && (
                          <a
                            className={classes.showSeatMap}
                            onClick={this.onClickCheckoutModalScheduleToggle}
                          >
                            Show game schedule
                          </a>
                        )}
                      </span>
                      <span>
                        $
                        {this.props.formStyle === "classic"
                          ? this.props.seatInfoSelected.price
                            ? this.props.seatInfoSelected.price.toLocaleString(
                                "en-US"
                              )
                            : null
                          : (
                              this.props.seatInfoSelected.price * flexMultiply
                            ).toLocaleString("en-US")}
                        <br />
                        per{" "}
                        {this.props.formStyle === "classic" ? "seat" : "plan"}
                      </span>
                    </div>
                    <div className={classes.orderSummaryPlan}>
                      {this.props.seatInfoSelected &&
                        this.state.seatLocation && (
                          <>
                            <span className={classes.labelName}>
                              Seating Location
                            </span>
                            <span>
                              {this.props.seatInfoSelected.name}
                              <br />
                              {this.props.formStyle === "classic"
                                ? section
                                : null}
                              {console.log(
                                "this.props.seatInfoSelected.name",
                                this.props.seatInfoSelected.name
                              )}
                              <br />
                              {this.props.formStyle === "classic" && (
                                <div className={classes.seatingInfo}>
                                  {rows &&
                                    rows.map((item, i) => {
                                      return Object.keys(item).map((key) => {
                                        if (Array.isArray(item[key])) {
                                          return (
                                            <div key={(key + i).toString()}>
                                              <span>
                                                <span
                                                  className={
                                                    classes.seatingInfo_left_text
                                                  }
                                                >
                                                  Row:{" "}
                                                </span>
                                                <span>{key}</span>
                                                <br />
                                                <span>
                                                  <span
                                                    className={
                                                      classes.seatingInfo_left_text
                                                    }
                                                  >
                                                    Seat(s):{" "}
                                                  </span>
                                                  {item[key].map((seat, j) => (
                                                    <span
                                                      key={(key + j).toString()}
                                                    >
                                                      {" "}
                                                      {seat}
                                                      {j + 1 < item[key].length
                                                        ? ", "
                                                        : ""}
                                                    </span>
                                                  ))}
                                                </span>
                                              </span>
                                              <br />
                                              <br />
                                            </div>
                                          );
                                        }
                                        return false;
                                      });
                                    })}
                                </div>
                              )}{" "}
                              {/* {this.props.formStyle === "classic" && (
                              <a
                                className={classes.showSeatMap}
                                onClick={this.onClickCheckoutModalToggle}
                              >
                                Show seating map
                              </a>
                            )} */}
                            </span>
                          </>
                        )}
                    </div>

                    {/* <div className={classes.orderSummaryPlan}>
                      {this.props.numOfSeat && (
                        <>
                          <span className={classes.labelName}>Quantity</span>
                          <span>{this.props.numOfSeat}</span>
                        </>
                      )}
                    </div> */}
                    <div className={classes.orderSummaryCost}>
                      <span className={classes.labelName}>Subtotal</span>
                      <span>
                        ${this.state.totalInfo.subTotal.toLocaleString("en-US")}
                      </span>
                    </div>
                    <div className={classes.orderSummaryCost}>
                      <span className={classes.labelName}>Processing Fee</span>
                      <span>
                        $
                        {this.state.totalInfo.ticketServiceCharges.toLocaleString(
                          "en-US"
                        )}
                      </span>
                    </div>
                    <div className={classes.orderSummaryCost}>
                      <span className={classes.labelName}>Total</span>
                      <span>
                        ${this.state.totalInfo.total.toLocaleString("en-US")}
                      </span>
                    </div>
                    <div className={classes.orderSummaryCost}>
                      {this.state.selectedPaymentPlan && (
                        <span className={classes.labelName}>Total Due Now</span>
                      )}
                      <span>
                        $
                        {this.numberFormat(
                          this.state.selectedPaymentPlan.planPrice,
                          2,
                          ".",
                          ","
                        )}
                      </span>
                    </div>
                  </div>
                  <div className={classes.formInput}>
                    <div className={classes.formTitle}>Personal Info</div>
                    <PersonalForm
                      onChangePersonalForm={this.onChangePersonalForm}
                    />
                    <div className={classes.formTitle}>Payment Info</div>
                    <CheckoutForm
                      authorization={this.state.clientToken}
                      cartId={this.state.cartId}
                      onClickCheckoutSubmit={this.onClickCheckoutSubmit}
                      validationErrorMsg={this.state.validationErrorMsg}
                      validation={this.state.validation}
                      personalInfo={this.state.personalInforResult}
                    >
                      {this.state.paymentPlanOptions &&
                        this.state.paymentPlanOptions.length > 1 && (
                          <>
                            <div className={classes.formTitle}>
                              Payment Plans
                            </div>
                            <div className={classes.formPaymentPlan}>
                              {this.state.paymentPlanOptions.map(
                                (option, i) => {
                                  return (
                                    <label
                                      key={option.id}
                                      className={classes.formPaymentPlan__input}
                                    >
                                      <input
                                        type="radio"
                                        className={this.props.className}
                                        name="paymentPlan"
                                        checked={
                                          this.state.selectedPaymentPlan
                                            .index === i
                                            ? true
                                            : false
                                        }
                                        key={option.id}
                                        onChange={this.onChangePaymentPlan.bind(
                                          this,
                                          {
                                            ...option,
                                            index: i,
                                          }
                                        )}
                                        value={option.id}
                                      />
                                      {option.description}
                                    </label>
                                  );
                                }
                              )}
                            </div>
                            {this.state.selectedPaymentPlan.index !== 0 && (
                              <div className={classes.disclaimer__plan}>
                                <p>
                                  <strong>
                                  If you have selected an automatically renewing
                                  plan, you understand and agree that your plan
                                  is an annual commitment and will automatically
                                  renew on an annual basis on September 1 each
                                  year, unless you cancel.</strong> If you have questions
                                  about your plan or payments or would like to
                                  change your payment option after you complete
                                  your purchase, please contact your ticket
                                  representative. You may cancel your plan by
                                  email to{" "}
                                  <a href="mailto:stcomments@nationals.com">
                                    stcomments@nationals.com
                                  </a>
                                  , by calling (202) 675-6287 (NATS), or by
                                  completing the form{" "}
                                  <a
                                    href="https://www.mlb.com/nationals/tickets/season-tickets/plans/plan-opt-out"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    here
                                  </a>{" "}
                                  . If you do not cancel on or before August 31
                                  of the following year, your total commitment
                                  may increase. The Nationals will provide you
                                  with a separate document showing the amount
                                  you will pay each subsequent season. If you
                                  cancel, you are still bound by the terms of
                                  the payment plan you have selected and will be
                                  obligated to make all payments for the
                                  then-current year. However, your membership or
                                  plan will not automatically renew for
                                  subsequent seasons.
                                </p>
                                <p>
                                  A separate agreement must be signed in order
                                  to finalize the purchase of certain
                                  memberships and plans. If the membership or
                                  plan you selected is one of those, a Nationals
                                  account representative will distribute an
                                  agreement to you electronically to the email
                                  address that you have provided to us and the
                                  agreement must be signed in order for you to
                                  complete your purchase. If you do not execute
                                  the agreement within the time period specified
                                  by the Nationals, the Nationals may cancel
                                  your purchase and/or require you to pay a
                                  higher price for your membership or plan.
                                </p>
                                <h3>Installment Schedule</h3>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Installments</th>
                                      <th>Due Date</th>
                                      <th>Installment Amount</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>1</td>
                                      <td>Due Now</td>
                                      <td>
                                        $
                                        {this.numberFormat(
                                          this.state.selectedPaymentPlan
                                            .planPrice,
                                          2,
                                          ".",
                                          ","
                                        )}
                                      </td>
                                    </tr>

                                    {this.state.selectedPaymentPlan
                                      .installments &&
                                      this.state.selectedPaymentPlan.installments.map(
                                        (item, i) => (
                                          <tr key={i * 100}>
                                            <td>{i + 2}</td>
                                            <td>
                                              {moment(item["date"]).format(
                                                "LL"
                                              )}
                                            </td>
                                            <td>
                                              {item[
                                                "display-value"
                                              ].toLocaleString("en-US")}
                                            </td>
                                          </tr>
                                        )
                                      )}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </>
                        )}
                    </CheckoutForm>
                  </div>
                </div>
                <CheckoutModal
                  seatInfoSelectedName={this.props.seatInfoSelected.name}
                  checkoutModalToggle={this.state.checkoutModalToggle}
                  onClickCheckoutModalToggle={this.onClickCheckoutModalToggle}
                />
                <CheckoutModalSchedule
                  formSize={this.props.formSize}
                  checkoutModalScheduleToggle={
                    this.state.checkoutModalScheduleToggle
                  }
                  onClickCheckoutModalScheduleToggle={
                    this.onClickCheckoutModalScheduleToggle
                  }
                  planSchedules={this.state.planSchedules}
                />
                <div className={classes.disclaimer}>
                  <p>
                    - Payment Authorization: You authorize the Nationals to seek
                    the payments set forth above on or after the due dates set
                    forth above less any prepayments or other credits applied to
                    this amount by initiating a charge to the credit or debit
                    card specified online in your Tickets.com account, or any
                    subsequent credit or debit card(s) you provide to the
                    Nationals (your “Card”) (each charge, a “Charge”). If any
                    payment subject to this invoice is returned unpaid, you
                    authorize the Nationals to resubmit a charge up to two
                    additional times (or any greater number permitted by law)
                    and/or cancel your tickets immediately.
                  </p>
                  <p>
                    - In the event the Nationals make an error in processing a
                    Charge, you authorize the Nationals to correct the error. If
                    you inadvertently transpose a digit or make a similar error
                    when providing information about a payment method, you
                    authorize the Nationals to correct the error after verifying
                    the information with you. Instead of or in addition to any
                    payments described above, you authorize the Nationals to
                    initiate a Charge to the Card for any amount and on any date
                    that you subsequently confirm by phone, text message, or
                    email.
                  </p>
                  <p>
                    - You have the right to receive written notice if any
                    payment will vary from the amount authorized above. To
                    exercise this right, send a written request to your ticket
                    representative; otherwise, you authorize the Nationals to
                    vary the amount of any scheduled payment without notice, so
                    long as such payment is at least 80% and no more than 110%
                    of the amount you authorize above.
                  </p>
                  <p>
                    - You understand that your financial institution may charge
                    you a fee if any payment authorized above is dishonored or
                    returned unpaid, and you agree that the Nationals will have
                    no liability regarding any such fees. You understand that a
                    Charge may not immediately post to the Card. You agree to
                    notify the Nationals immediately of any change in the status
                    of your Card. You certify that you are an authorized user of
                    the Card. Each Charge to the Card will be processed in U.S.
                    Dollars.
                  </p>
                  <p>
                    - You may revoke this authorization by calling (202)
                    675-NATS or emailing stcomments@nationals.com in such time
                    and manner as to afford the Nationals a reasonable
                    opportunity (typically three business days) to act on your
                    request. If you revoke this authorization you will still be
                    responsible for paying any amounts you owe.
                  </p>
                  <p>
                    - All sales are final. There are no refunds or exchanges.
                    For additional terms and conditions that govern your
                    purchase please{" "}
                    <a
                      href="https://www.mlb.com/nationals/tickets/terms-and-conditions?_gl=1*1e2iov0*_gcl_au*MjA0NDE3MzE5MS4xNzI5MDg3NDIw"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      click here
                    </a>
                    .
                  </p>
                  <div className={classes.arrow_down_bg} />
                  <div className={classes.arrow_down}>
                    <div className={classes.scroll_arrow}></div>
                    <div className={classes.scroll_arrow}></div>
                    {/* <div className={classes.scroll_arrow}></div> */}
                  </div>
                </div>
              </>
            ) : (
              <div className={classes.errorMsg}>
                {this.state.error && (
                  <p>
                    {" "}
                    Sorry! There is an error. Please click the “Chat with
                    Representative” button below or e-mail us at
                    TicketInfo@Nationals.com to finalize your order.
                  </p>
                )}
              </div>
            )}
          </div>
        )}
        <div
          className={cx(
            classes.loader__wrapper,
            this.state.loaderShow ? classes.loader__wrapper__active : ""
          )}
        >
          <div className={classes.loader}>
            <div className={classes["lds-ring"]}>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
        <FormController
          backTo={
            this.props.formSize === "ballPark"
              ? "recommended-plan"
              : "select-your-seats"
          }
          nextTo=""
          startOver={ROUTES.PAGE_1_LINK}
          showBack={true}
          showStartOver={true}
          showSkip={false}
          showSubmit={false}
        />
      </>
    );
  }
}
export default withRouter(Checkout);
